mutation UpdateMoneyPage($input: UrlUpdateInput!) {
    maUrlUpdate(input: $input) {
        url {
            id
            name
        }
    }
}
